import { Component, HostBinding, Input, OnChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnChanges {
  @HostBinding('class.show') showErrors;
  @Input('on') on;
  @Input('control') control: AbstractControl;
  controlIsInvalid = true;
  constructor() { }

  ngOnChanges(changes) {
    if (changes['control']) {
      if (!this.control) {
        this.controlIsInvalid = true;
      } else {
        this.controlIsInvalid = !!this.control.errors;
        this.control.statusChanges.subscribe(status => {
          this.controlIsInvalid = !!this.control.errors;
          this.showErrors = !!this.on && this.controlIsInvalid;
        });
      }
    }
    // If 'on' is a string (error message), show it regardless of control state
    // If 'on' is a boolean/truthy and there's a control, check control validity
    if (typeof this.on === 'string' && this.on.trim().length > 0) {
      this.showErrors = true;
    } else {
      this.showErrors = !!this.on && this.controlIsInvalid;
    }
  }
}
